import { createAxios } from '../lib/axiosFactory';
import { dataCollectionParser, dataParser } from '../lib/response/dataParser';
import { errorParser } from '../lib/response/errorParser';
import { ActionResponse } from '../lib/interfaces/actionResponse';
import _ from 'lodash';

export const state = {
  columns: []
};

export const mutations = {
  setColumns(state: any, columns: any[]): void {
    state.columns = columns;
  }
};

export const actions = {
  async loadColumns(
    { commit },
    options: { predefined?: boolean; archived?: boolean }
  ): Promise<ActionResponse> {
    try {
      const response = await createAxios().get('/backend/columns-index', {
        params: {
          ...(typeof options?.predefined !== 'undefined' && {
            'filter[predefined][val]': options?.predefined,
            'filter[predefined][op]': 'eq'
          }),
          ...(typeof options?.archived !== 'undefined' && {
            'filter[archived][val]': options?.archived,
            'filter[archived][op]': 'eq'
          })
        }
      });

      const columns = dataCollectionParser(response);
      commit('setColumns', columns);
      return { success: true, errors: {}, body: columns };
    } catch (error) {
      return {
        success: false,
        errors: errorParser(error),
        body: error.response.data
      };
    }
  },
  async loadColumnDetails({ commit }, id: string): Promise<ActionResponse> {
    try {
      const response = await createAxios().get('/backend/columns-show', {
        params: {
          id
        }
      });

      return {
        success: true,
        errors: {},
        body: dataParser(response.data.data)
      };
    } catch (error) {
      return {
        success: false,
        errors: errorParser(error),
        body: error.response.data
      };
    }
  },
  async createColumn(
    { rootState },
    payload: Record<string, unknown>
  ): Promise<ActionResponse> {
    try {
      const response: any = await createAxios().post(
        '/backend/columns-create',
        {
          data: {
            id: payload.id,
            type: 'columns',
            attributes: _.omit(payload, 'id')
          }
        }
      );

      return { success: true, errors: {}, body: response.data.data };
    } catch (error) {
      return {
        success: false,
        errors: errorParser(error),
        body: error.response.data
      };
    }
  },
  async updateColumn(
    { rootState },
    payload: Record<string, unknown>
  ): Promise<ActionResponse> {
    try {
      const response: any = await createAxios().patch(
        '/backend/columns-update',
        {
          data: {
            type: 'columns',
            attributes: _.omit(payload, 'id')
          }
        },
        { params: _.pick(payload, 'id') }
      );

      return { success: true, errors: {}, body: response.data.data };
    } catch (error) {
      return {
        success: false,
        errors: errorParser(error),
        body: error.response.data
      };
    }
  }
};
